import type { Theme } from '@mui/material';

export function getTransition(theme: Theme) {
  return theme.transitions.create(['transform', 'background-color'], {
    duration: theme.transitions.duration.shortest,
    easing: theme.transitions.easing.easeOut,
  });
}
